import { z } from 'zod'

import { InstalledTemplateSchema } from 'shared/api/common/schemas/templates/installedTemplate'

export const templatesApiSchemas = {
  fetch: {
    path: z.undefined(),
    query: z.object({
      hash: z.string().nullable(),
    }),
    request: z.undefined(),
    response: z.object({ templates: z.array(InstalledTemplateSchema) }),
  },
  fetchTemplate: {
    path: z.undefined(),
    query: z.object({ template_installation_id: z.number().or(z.string()) }),
    request: z.undefined(),
    response: z.object({ item: InstalledTemplateSchema }),
  },
  uninstall: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.object({
      template_installation_id: z.string(),
      delete_ice_breakers: z.boolean().optional(),
      delete_main_menu: z.boolean().optional(),
      delete_subscribers_data: z.boolean().optional(),
    }),
    response: z.undefined(),
  },
}
